import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom'
import Hide from '../../../styles/utilities/Hide'
import Icon from '../../elements/Icon/Icon'
import MobileMenu from '../../modules/MobileMenu'
import Dropdown from '../../elements/Dropdown'
import DropdownList from '../../elements/DropdownList'
import ClickOut from '../../elements/ClickOut'

import { revokeToken } from '../../../alelo-logic/services/common/apolloClient'

import ChoosePlanDropdown from '../../modules/ChoosePlanDropdown'
import { headerMenuLinks } from './data.json'

import {
  Avatar,
  HeaderWrapper,
  HeaderContainer,
  FlexContainer,
  // HelpLink,
  Logo,
  VerticalSpacer,
  UserInfoContainer,
  UserDropdownInfo
} from './styles'

import avatarPj from '../../../static/avatars/avatar-pj.png'

const avatarList = [
  require('../../../static/avatars/avatar-1.png'),
  require('../../../static/avatars/avatar-2.png'),
  require('../../../static/avatars/avatar-3.png'),
  require('../../../static/avatars/avatar-4.png'),
  require('../../../static/avatars/avatar-5.png'),
  require('../../../static/avatars/avatar-6.png'),
  require('../../../static/avatars/avatar-7.png'),
  require('../../../static/avatars/avatar-8.png')
]

class Header extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isUserDropdownOpen: false,
      isPlanDropdownOpen: false,
      isMobileMenuOpen: false,
      isChoosePlanOpen: true
    }
  }

  toggleDropdownList = () => {
    this.setState({
      isUserDropdownOpen: !this.state.isUserDropdownOpen
    })
  }

  closeDropdownList = () => {
    this.setState({
      isUserDropdownOpen: false
    })
  }

  toggleMobileMenu = () => {
    this.setState({
      isMobileMenuOpen: !this.state.isMobileMenuOpen
    })
  }

  closeMobileMenu = () => {
    this.setState({
      isMobileMenuOpen: false
    })
  }

  mapLogoutAction = (menu, doLogout, history) =>
    menu.map(itemMenu => {
      if (itemMenu.isLogout) {
        return {
          ...itemMenu,
          onClick: () => {
            history.push('/conta/login')
            doLogout()
          }
        }
      }

      return itemMenu
    })

  filterInvisibleItens = (menu, active) => {
    const filterLabel = active ? 'active' : 'canceled'
    return menu.filter(
      itemMenu =>
        !itemMenu.exclude ||
        (Array.isArray(itemMenu.exclude) && !itemMenu.exclude.includes(filterLabel))
    )
  }

  render() {
    const { userCancelled, avatar, account, doLogout, history, accountPlans } = this.props
    // Verifica se existe o at referente a perfil ativação.
    const profileActivationType = (account || {}).at || (account || {}).pc ? 'at' : ''
    // Menu Options By Account Type
    let headerMenuOptions = headerMenuLinks[profileActivationType || account.accountType] || []

    // Map Logout Action on Menu
    headerMenuOptions = this.mapLogoutAction(headerMenuOptions, doLogout, history)

    // Exclude not visible menu itens
    headerMenuOptions = this.filterInvisibleItens(headerMenuOptions, account.active)

    const resumeLink = `/minha-veloe${
      accountPlans.activePlanId ? `/${accountPlans.activePlanId}/` : '/'
    }resumo`
    const accountTypeLabel = account.accountType === 'pf' ? 'Pessoal' : 'Empresarial'

    return (
      <HeaderWrapper>
        <HeaderContainer>
          <FlexContainer>
            <Link to={resumeLink}>
              <Icon icon="veloe-logo" svgStyle={Logo} width="74" height="31" viewBox="0 0 74 31" />
            </Link>

            <Hide at="large">
              {this.state.isMobileMenuOpen ? (
                <a href="#a" onClick={this.toggleMobileMenu}>
                  <Icon icon="close" svgStyle="height: 15px; width: 22px" viewBox="0 0 14 14" />
                </a>
              ) : (
                <a href="#a" onClick={this.toggleMobileMenu}>
                  <Icon icon="hamburger" width="22" height="15" viewBox="0 0 22 15" />
                </a>
              )}
            </Hide>

            <Hide at="small">
              <ChoosePlanDropdown />
            </Hide>
          </FlexContainer>
          <Hide at="large">
            <MobileMenu
              avatar={avatarList[avatar]}
              isOpen={this.state.isMobileMenuOpen}
              menuOptions={headerMenuOptions}
              categoryLabel={accountTypeLabel}
              username={account.name}
              headerLabelCategory="profile"
              onClose={this.closeMobileMenu}
              userCancelled={userCancelled}
              profileActivationType={profileActivationType === 'at'}
            />
          </Hide>
          <Hide at="small">
            <FlexContainer>
              {/* <HelpLink href="#">Ajuda</HelpLink> */}
              <VerticalSpacer />
              <UserInfoContainer>
                <ClickOut callback={() => this.closeDropdownList()}>
                  <UserDropdownInfo isOpen={this.state.isUserDropdownOpen}>
                    <Avatar src={account.accountType === 'pj' ? avatarPj : avatarList[avatar]} />
                    <Dropdown
                      categoryLabel={accountTypeLabel}
                      dropdownLabel={account.name}
                      headerLabelCategory="profile"
                      onClick={this.toggleDropdownList}
                    />
                  </UserDropdownInfo>
                  <DropdownList
                    options={headerMenuOptions}
                    isOpen={this.state.isUserDropdownOpen}
                    onClose={this.closeDropdownList}
                    userCancelled={userCancelled}
                  />
                </ClickOut>
              </UserInfoContainer>
            </FlexContainer>
          </Hide>
        </HeaderContainer>
      </HeaderWrapper>
    )
  }
}

Header.defaultProps = {
  account: {},
  userCancelled: false
}

Header.propTypes = {
  account: PropTypes.shape({
    name: PropTypes.string,
    accountType: PropTypes.string
  }),
  userCancelled: PropTypes.bool
}

const mapStateToProps = state => ({
  user: state.reducer.user.profile,
  avatar: state.header.avatar,
  account: state.reducer.account,
  accountPlans: state.reducer.accountPlans
})

const mapDispatchToProps = dispatch => ({
  doLogout: () => {
    revokeToken()
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header))



// WEBPACK FOOTER //
// ./src/app/modules/Header/index.js